// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.game-image-upload-wrapper {
  overflow: auto;
  background-color: rgba(138, 155, 168, 0.15);
}
.game-image-upload-wrapper .image-preview {
  display: block;
  max-width: 100%;
}
.game-image-upload-wrapper .image-dropzone-button {
  width: 100%;
}
.image-dropzone-button {
  padding: 6.4px 6px;
}
.card-dropzone {
  background-color: rgba(138, 155, 168, 0.15);
}
.card-dropzone .nkl-card-head {
  border-bottom: 0;
  padding: 0 10px;
  text-align: left;
}
/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */
/* stylelint-disable no-duplicate-selectors */
/* stylelint-disable */
/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
